import { BaseController } from '../../../common/base/controller';
import { OldPortfolioMessages } from '../../../components/oldPortfolio/oldPortfolio.constant';

class OldBankInputController extends BaseController {
  constructor(controllerService, $scope) {
    'ngInject';
    super({
      controllerService,
      $scope,
    });
  }

  $onInit() {
    this.messages = OldPortfolioMessages;

    this.$scope.$watch('vm.model.oldAccountNumber', (newValue) => {
      if (!this.form.oldAccountNumber) return;

      this.form.oldAccountNumber.$setValidity(
        'oldAccountNumberEqualsNewAccountNumber',
        this.oldAccountNumberNotEqualsNewAccountNumber(
          this.model.oldAccountNumber,
        ),
      );
    });

    this.$scope.$watch('vm.model.shortName', (newValue) => {
      if (!this.form.oldBank) return;

      this.form.oldBank.$setValidity(
        'invalidBankIdentifier',
        this.oldBankIsValid(this.model),
      );
    });
  }

  selectBank(bank) {
    // banksearch returns blz as legacyBankIdentifier and bankCode, fallback if one of them dont exist
    this.model.legacyBankIdentifier = bank.legacyBankIdentifier
      ? bank.legacyBankIdentifier
      : bank.bankCode;
  }

  oldBankIsValid(bank) {
    return bank && !!bank.legacyBankIdentifier;
  }

  oldAccountNumberNotEqualsNewAccountNumber(oldAccountNumber) {
    const newBank = this.appCache.get('newBank');
    if (!newBank) {
      return;
    }

    // Compare old and new account number without considering spaces and case of string
    const newAccountNumber = newBank.portfolioId;
    return (
      `${oldAccountNumber}`.replace(/\s+/g, '').toLowerCase() !==
      `${newAccountNumber}`.replace(/\s+/g, '').toLowerCase()
    );
  }
}

export default OldBankInputController;



// WEBPACK FOOTER //
// ./src/app/common/ui/oldBankInput/oldBankInput.controller.js